import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "89f8d213-a87f-4fe5-bf81-765205c87f56",
    content: "fc<sup>1</sup>= 10 044 Hz <br>cg1 = 3 428 m/s <br>Δt = -2.6 ms",
    options: {},
  },
  {
    id: "eda5cd70-2ed9-4fd8-b4fc-59ace724df84",
    content: "fc<sup>1</sup>= 5 022 Hz <br>cg1 = 311 m/s <br>Δt = 0.29 ms",
    options: {},
  },
  {
    id: "b180f615-1b40-4b40-9672-ab8abdab258e",
    content: "fc<sup>1</sup>= 5 459 Hz <br>cg1 = 305 m/s <br>Δt = 0.36 ms",
    options: {},
  },
  {
    id: "5200ee61-5312-4d43-b137-59a475dcff3c",
    content: "fc<sup>1</sup>= 63 112 Hz <br>cg1 = 1 771 m/s <br>Δt = -2.35 ms",
    options: {},
  },
  {
    id: "41fec9e4-0dec-456b-9ff8-71d793623f26",
    content: "fc<sup>1</sup>= 10 044 Hz <br>cg1 = 627 m/s <br>Δt = -1.3 ms",
    options: {},
  },
  {
    id: "5b195ada-19f5-4d2d-9898-f512eab67b83",
    content: "fc<sup>1</sup>= 10 044 Hz <br>cg1 = 188 m/s <br>Δt = 2.4 ms",
    options: {},
  },
];

export const task: Task = {
  id: "bd69264d-3588-40c4-9048-648c4bd3f3cf",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["5b195ada-19f5-4d2d-9898-f512eab67b83"],
};
